// @flow
import React from "react"
import { Text } from "componentsStyled/Typography/Texts"
import Checkbox from "components/Checkbox"
import { TermsAndConditionsContent, CheckboxWrap, Confirmation } from "./styled"
import CollapsiblePanel from "components/CollapsiblePanel"

type Props = {
  accepted?: boolean,
  setAccepted: (accepted: boolean) => void,
}

export const TermsAndConditions = ({ accepted, setAccepted }: Props) => {
  setAccepted(accepted || false)
  return (
    <React.Fragment>
      <TermsAndConditionsContent>
        <p>
          You (“Awayco Partner”) agree with the below terms and engage the
          services of Awayco Inc. in accordance with these terms.
        </p>
        <CollapsiblePanel group="Terms and Conditions of Becoming an Awayco Partner">
          <p className="center">
            Terms and Conditions of Becoming an Awayco Partner
          </p>
          <br />
          <ol>
            <li>
              This service is consistent with the Awayco Terms of Service
              available here. By continuing with the self-onboarding process and
              using the Awayco Service you are agreeing to the Awayco Terms of
              Service at{" "}
              <a href="https://awayco.com/terms">https://awayco.com/terms</a>.
            </li>
            <li>
              <b>Pricing</b>
              <ol>
                <li>
                  Awayco shall collect the base level 15% per transaction and
                  pay the balance of transactions to the Awayco Partner on a
                  weekly basis.
                </li>
              </ol>
            </li>
            <li>
              <b>Awayco responsibilities</b>
              <ol>
                <li>
                  Create and maintain your Awayco listing and store inventory
                  including rich store page detail and rich product pages for
                  suitable products.
                </li>
                <li>
                  Provide you with staff training and live support from time to
                  time.
                </li>
                <li>
                  Provide you with an Awayco store page for your own website to
                  announce to your store customers.{" "}
                </li>
                <li>
                  Provide you with an Awayco shop login available at
                  shop.awayco.com and Awayco admin login available at
                  admin.awayco.com.
                </li>
              </ol>
            </li>
            <li>
              <b>Your responsibilities</b>
              <ol>
                <li>
                  Maintain standards of retail excellence in connection with the
                  use of Awayco technology, including high quality:
                  <ol>
                    <li>Customer service</li>
                    <li>Product assortment</li>
                    <li>
                      Safety, servicing, conditioning and maintenance of
                      inventory to ensure they are kept in excellent working
                      condition and fit for use
                    </li>
                    <li>
                      Display of appropriate Awayco branding and merchandising
                      of Awayco logo and information on store premises.
                    </li>
                    <li>
                      Use of Awayco shop login technology to service customers
                      as they walk into the store.
                    </li>
                    <li>
                      Fulfill Awayco bookings accurately and in a timely manner
                      via the shop console or via email notification.
                    </li>
                    <li>
                      Maintain accurate opening hours and up to date store and
                      inventory information via your admin console on
                      admin.awayco.com
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>
              <b>Payments and Remittance </b>
              <ol>
                <li>
                  Store does not pay for the Awayco service until the service is
                  activated by at least 1 booking.{" "}
                </li>
                <li>
                  All Awayco shop partners will operate on the same payment
                  cycle starting on the 1st of the month ending at month-end.{" "}
                </li>
                <li>
                  Awayco will capture and disburse payment to the partner no
                  later than 7 (seven) days after month-end.
                </li>
              </ol>
            </li>
            <li>
              <b>Release of Liability</b>
              <ol>
                <li>
                  The Store is uniquely and solely liable for risk associated
                  with the rental, leasing, or placing at disposal, gear for the
                  purpose of outdoor recreation. Awayco is in no way liable for
                  any risk or damage to property or persons whatsoever in
                  connection with the Store's activity in rental, leasing, or
                  placing at disposal, gear for the purpose of outdoor
                  recreation.
                </li>
                <li>
                  Store partners must carry business liability insurance,
                  specific to the store-front per standard operating standards.{" "}
                </li>
                <li>
                  Store-front must carry liability insurance on inventory
                  rentals from the storefront addressing personal injury and
                  claims against user injury by individuals or to third parties.
                </li>
                <li>
                  All end users must be educated and aware of their own release
                  of liability to both the store operator and Awayco.
                </li>
                <li>
                  End-users must be verbally educated and informed of the
                  inherent dangers and risk of injury or death due to
                  participation in the given sport vertical.{" "}
                </li>
                <li>
                  Any and all adjustments made to gear is the responsibility of
                  the partner storefront, the shop is liable for any and all
                  claims due to improper adjustment to equipment.{" "}
                </li>
              </ol>
            </li>
            <li>
              <b>Damage Coverage</b>
              <ol>
                <li>
                  Store agrees to the definitions of damage expressed on{" "}
                  <a href="https://awayco.com/terms">
                    https://awayco.com/terms
                  </a>
                </li>
                <li>
                  Store agrees to inspect and document the condition of all
                  products prior to handing them to Awayco customers and to
                  ensure they are in good and functioning condition for use.
                </li>
                <li>
                  Store agrees to evaluate damage at its sole discretion on the
                  return of a product after it has been used by an Awayco
                  customer.
                </li>
                <li>
                  The Store may mark a product as damaged once returned by an
                  Awayco customer, based on prescribed damage levels: "minor",
                  "medium", "major", and "broken beyond repair".
                </li>
                <li>
                  Customer is able to purchase product damage cover with their
                  product reservations, which has the effect of removing the
                  liability to pay for any such damage occasioned to a Product
                  during use by the customer.
                </li>
                <li>
                  Customer is responsible for paying the cost of damages unless
                  they have purchased product damage cover in which case the
                  Awayco Partner will cover the damage.
                </li>
                <li>
                  Any damage claim by a store may be assessed by Awayco to check
                  it is valid and bona fide.
                </li>
                <li>
                  Valid damage claims by a store will be remitted as part of
                  regular disbursements.
                </li>
                <li>
                  Valid damage claims by a store will attract the damage rates
                  outlined by the Awayco partner in their shop app.
                </li>
                <li>
                  Awayco and the store agree that damage costs will not fall
                  below the salvage value of the good or landed cost of the
                  goods, whichever is the lesser.
                </li>
              </ol>
            </li>
            <li>
              <b>Promotions</b>
              <ol>
                <li>
                  Awayco has the right to make promotional offers from time to
                  time that may include price incentives, the store agrees to
                  accept these bookings at the promotional prices.
                </li>
                <li>
                  Store agrees to accept bookings from a limited membership of
                  “Perks” loyalty members in exchange for the standard 15%
                  Awayco transaction fee. Stores may opt-out of receiving these
                  customers should they choose.
                </li>
              </ol>
            </li>
            <li>
              <b>Cancelations</b>
              <ol>
                <li>
                  Canceling the Awayco service requires the store partner to
                  send an email to support@awayco.com notifying their intent to
                  switch off the Awayco service and terminate their account.
                </li>
                <li>
                  The cancelation process may take up to 30 days to deactivate
                  the store partner monthly billing cycle.
                </li>
              </ol>
            </li>
            <li>
              <b>Disputes</b>
              <ol>
                <li>
                  All disputes must be addressed within 30 days of the
                  transaction or reporting event.
                </li>
                <li>
                  Any dispute that is unable to be settled in an amicable manner
                  will go to 3rd party arbitration.
                </li>
              </ol>
            </li>
          </ol>
        </CollapsiblePanel>

        <Confirmation>
          <CheckboxWrap>
            <Checkbox value={accepted} onClick={() => setAccepted(!accepted)} />
          </CheckboxWrap>
          <Text black bold>
            Agree with the Terms and Conditions
          </Text>
        </Confirmation>
      </TermsAndConditionsContent>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/pages/AffiliateRegistration/TermsAndConditions/index.js